import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Observable } from 'rxjs';
import { getObjetivesById, getObjetivesByPerspective } from './querys';
import { Apollo } from 'apollo-angular';

export class Objetivos {
  public id?: Number;
  public name?: String;
  public description?: String;
  public weighing?: Number;
  public perspectiveId?: Number;
  public responsibleIds?: Number[];
}

@Injectable({
  providedIn: 'root'
})
export class ObjetivoService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private apollo: Apollo
  ) { }

  public getObjetivos(): Observable<any> {
    const apiURL = `${this.apiURL}objetivos`;
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }

  async getObjectivesByIdGQL(id: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getObjetivesById,
        context: {headers: this.headers},
        variables: {objectiveId: id}
      }).valueChanges
    );
    return data.objective;
  }

  async getObjectivesByPerspectiveGQL(perspective: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getObjetivesByPerspective,
        context: {headers: this.headers},
        fetchPolicy: 'no-cache',
        variables: {
          "args": {
            "filter": {
              "operator": "AND",
              "conditions": [
                {
                  "field": "perspectiveId",
                  "operator": "EQUAL",
                  "value": `${perspective}`
                }
              ]
            }
          }
        }
      }).valueChanges
    );
    return data.searchObjectives.data;
  }

  public postObjetivos(obj: any): Observable<any> {
    const objet: Objetivos = {
      name: obj.nombre,
      description: obj.descripcion,
      weighing: Number(obj.ponderacion),
      perspectiveId: Number(obj.perspectiveId),
      responsibleIds: [Number(obj.responsableId)],
    }
    const body = JSON.stringify(objet);
    const apiURL = `${this.apiURL}objetivos`;
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchObjetivos(obj: any): Observable<any> {
    const objec: Objetivos = {
      name: obj.nombre,
      description: obj.descripcion,
      weighing: Number(obj.ponderacion),
      perspectiveId: Number(obj.perspectiveId),
      responsibleIds: [Number(obj.responsableId)],
    }
    const body = JSON.stringify(objec);
    const apiURL = `${this.apiURL}objetivos/${obj.id}`;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public patchObjetivosPon(obj: any): Observable<any> {
    const objec: Objetivos = {
      weighing: Number(obj.ponderacion),
    }
    const body = JSON.stringify(objec);
    const apiURL = `${this.apiURL}objetivos/${obj.id}`;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteObjetivos(obj: any): Observable<any> {
    const apiURL = `${this.apiURL}objetivos/${obj.id}`;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }
}
